

/// <reference path="DocumentTemplate.ts" />

// Generated class SalesInvoiceTemplate_ManagedObject

class SalesInvoiceTemplate_ManagedObject extends DocumentTemplate
{
}
